import { Component, EventEmitter, Output, inject } from '@angular/core';
import { ALERT_TYPE } from 'src/app/constants';
import { Enums } from 'src/app/Shared/enums';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Company } from 'src/model/company.model';
import { CompanyService } from 'src/services/company.service';

@Component({
  selector: 'app-search-company-by-uid',
  templateUrl: './search-company-by-uid.component.html',
  styleUrls: ['./search-company-by-uid.component.scss'],
  standalone: false
})
export class SearchCompanyByUidComponent {
  protected sharedService = inject(SharedService);
  protected enums = inject(Enums);
  private companyService = inject(CompanyService);

  uid: string;
  company: Company;
  disabledSubmit = false;
  @Output() passEntry = new EventEmitter<any>();

  checkNull(uid: string) {
    if (uid == undefined)
      this.sharedService.openAlert("Please fill in UID!", ALERT_TYPE.DANGER);
    else
      this.searchCustomerByUid(uid);
  }

  async searchCustomerByUid(uid: string) {
    this.company = await this.companyService.getCompanyByUid(uid);
    this.passEntry.emit(this.company);
    this.uid = ""
  }
}
